import React, { Component } from 'react'


export default class About extends Component {
    render() {
        return (
<div className='about'>

          
    <div class='description'>
            <p><b>Sabine Holler</b> is a Brazilian, German descendant, singer, songwriter, music producer, multi-instrumentalist, and performance artist 
            currently based in Berlin, Germany. Her career started in 2008 when she founded the Brazilian experimental rock band, Jennifer Lo-Fi. 
            She also has been a vital part of Ema Stoned, Mawn, Barrie, and most recently Psymon Spine. She is currently working on her first solo album, TBA. 
            With more than a decade of career, Sabine has built a solid reputation in the independent music scene.
            </p>
            <p>

            Her sound travels through the genres of alternative, experimental and pop music. With the use of guitar, electronics, and strings, she builds up hypnotic layers of sound, harmoniously setting the perfect environment for her emotional and visceral singing.
            She started her career at the age of 16, in 2007 when she recorded her first compositions by herself and uploaded it to Myspace. She quickly gained attention from the music scene in São Paulo, leading her to meet the members of her first band, Jennifer Lo-fi.</p>
            <p>The group played together for eight years, gaining recognition and critic acclaim in the experimental rock scene in Brazil. Throughout their career, the band released five EPs, recorded with the Brazilian singer Mallu Magalhães, 
            got a sponsorship deal with the denin brand Levi's, and a nomination for "Aposta MTV" at the Brazilian MTV music awards in 2010 and released their recordings thought the label Deck Disk.
            During those years in Brazil, Sabine was one of the founders of the band Ema Stoned, an ambient/post-rock all-girl band that released two albums.
            </p>
            <p>

            In 2013, Sabine moved to Berlin to study Music Production and Sound Engineering where she met Björn Eichhorn and started the trip-hop electronica duo, Mawn, that self-produced and released two EPs and toured Europe and Japan.

            It was only in 2015 when Sabine started her solo project. At the end of 2016, she recorded her first solo EP, "Mother of Transition," and released it through the Brazilian feminist label Hérnia de Discos in 2017.
            </p>
            <p>

            Pursuing a more diverse music scene, she moved to New York in 2017 and joined the indie-pop band Barrie, where she played bass and singed backing-vocals. While being part of the group, the band released an EP and a full-length album, “Happy To Be There”, through the label Winspear. While promoting the album, the band toured North-America and Europe. Performed at MoMa Ps1, SXSW, BBC Maida Vale Sessions, and opened for artists like Hand Habits, Miya Folic.</p>
            <p>As Barrie continued as Barbara Lindsay’s solo project, a former member of Barrie, Noah Prebish invited Sabine to write and perform on the new Psymon Spine album, due to be released in 2020 by Northern Spy Records.

            Since 2018, Sabine is also a live singer for the Brazilian singer-songwriter Sessa. Having toured and performed in places such as KCRW, KEXP, Desert Dazed Festival, Brazil Summer Fest NYC, Montreal Tavern Festival, and opened for artists like Joe Bataan and Shintaro Sakamoto.
            </p>
    </div>
            
     
</div>

                
    
        )
    }
}
